export { Input } from "./Input";
export type { FloatLabel, InputProps, InputSize } from "./types";
